/**
 * Implementación del repositorio de Contractor usando HTTP
 */

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env';
import { ContractorRepository } from '@domain/repositories/contractor.repository';
import {
  ContractorUpdate,
  ContractorWorkItem
} from '@domain/models/contractor.model';
import {
  ContractorPatchDto,
  ContractorWorkItemDto
} from '@infra/dto/contractor.dto';
import {
  ContractorMapper,
  ContractorWorkItemMapper
} from '@infra/mappers/contractor.mapper';

@Injectable({ providedIn: 'root' })
export class ContractorRepositoryImpl implements ContractorRepository {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/v1/contractors`;

  updatePartial(contractorId: string, update: ContractorUpdate): Observable<void> {
    const payload = ContractorMapper.updateToDto(update);
    return this.http.patch<void>(`${this.baseUrl}/${contractorId}`, payload);
  }

  getWorks(): Observable<ContractorWorkItem[]> {
    return this.http.get<ContractorWorkItemDto[]>(`${this.baseUrl}/works`).pipe(
      map(dtos => ContractorWorkItemMapper.toDomainList(dtos))
    );
  }
}

